// extracted by mini-css-extract-plugin
module.exports = {"sectionContact":"Index_sectionContact_2Gxpb"};